// extracted by mini-css-extract-plugin
export default {"csvLink":"styles_csvLink__COYEn","nextBtn":"styles_nextBtn__WmkrS","panel":"styles_panel__uSR1i","elem":"styles_elem__MgZ06","list":"styles_list__zvf+P"};